// extracted by mini-css-extract-plugin
export default {"tags":"Tags_tags__isaGa","tag":"Tags_tag__cW8Lz","tagSelected":"Tags_tagSelected__adGri","viewMore":"Tags_viewMore__ZhS9l"};